let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("80Pzz")).then(() => parcelRequire('1gcu8'));